import { z } from 'zod'

export const schema = z.object({
  title: z.string(),
  caption: z.string(),
  metaDescription: z.string(),
  seoEnhancedText: z.string(),
  query: z.string(),
  isIndexable: z.boolean(),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  facetSlug: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
